import CustomBadge from '../../Dispatch/RouteExecution/DriverPopUp/common/CustomBadge';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  divStyle: {
    display: 'flex',
    justifyContent: 'center',
    margin: '4px 0px'
  }
});
const BadgeList = ({ classes, pieces, hu, weight, pse, palletCount }) => (
  <div className={classes.divStyle}>
    <CustomBadge value={pieces || 0} labelText="PCS" />
    <CustomBadge value={pse || 0} labelText="PSE" />
    <CustomBadge value={palletCount || 0} labelText="Pallets" />
    <CustomBadge value={hu || 0} labelText="HU" />
    <CustomBadge value={weight || 0} labelText="Weight" />
  </div>
);
export default withStyles(styles)(BadgeList);
